<template>
  <div>
    <slot
        :adminActive="isAdmin"
        :adminBusy="busy"
        :toggleAdmin="toggleAdmin"
        :withAdminLock="withLock"
    />
  </div>
</template>

<script>
export default {
  name: "AdminModeContext",

  data() {
    return {
      isAdmin: false,
      busy: false,
      timeoutHandle: null
    };
  },

  methods: {
    scheduleTimeout() {
      clearTimeout(this.timeoutHandle);

      this.timeoutHandle = setTimeout(() => {
        if (this.busy) {
          this.scheduleTimeout();
          return;
        }

        this.isAdmin = false;
      }, 100000);
    },

    toggleAdmin() {
      this.isAdmin = !this.isAdmin;

      if (this.isAdmin) {
        this.scheduleTimeout();
      } else {
        clearTimeout(this.timeoutHandle);
      }
    },

    withLock(fn) {
      return async () => {
        if (this.busy) return;

        this.busy = true;

        try {
          await fn();
        } finally {
          this.busy = false;

          if (this.isAdmin) {
            this.scheduleTimeout();
          }
        }
      };
    }
  },

  beforeDestroy() {
    clearTimeout(this.timeoutHandle);
  }
};
</script>
